import type {
  CreateTeamEventRequest,
  Crew,
  TeamEvent,
  TeamEventListResponse,
  TeamEventTodayResponse,
  TeamTodayResponse,
} from '@lemoment/shared';

import { apiClient } from '../../../core';

export const getTeamToday = (): Promise<TeamTodayResponse> =>
  apiClient.get('/team/today');

export const getCrews = (): Promise<{ crews: Crew[] }> =>
  apiClient.get('/crews');

export const getTeamEventsToday = (): Promise<TeamEventTodayResponse> =>
  apiClient.get('/team-events/today');

export const getTeamEvents = (query: {
  from: string;
  to: string;
}): Promise<TeamEventListResponse> =>
  apiClient.get(`/team-events?from=${query.from}&to=${query.to}`);

export const createTeamEvent = (
  body: CreateTeamEventRequest,
): Promise<TeamEvent> => apiClient.post('/team-events', body);

export const cancelTeamEvent = (id: string): Promise<TeamEvent> =>
  apiClient.del(`/team-events/${id}`);
